// @flow
import * as Immutable from 'immutable';
import ImmutableModel from 'common/models/flow/ImmutableModel';

type ClientStatus = 'ENABLED' | 'DISABLED';

type ClientStage =
    | 'TEST'
    | 'DEMO'
    | 'DEVO'
    | 'PILOT'
    | 'PRE_PROD'
    | 'PROD'
    | 'PROD_PLUS'
    | 'DEMO_INTERNAL';

export type MinimalClientModelType = {
    name: string,
    clientId: string,
    status: ClientStatus,
    stage: ClientStage,
    expiresOn: ?string,
    createdOn: string,
    isTest: boolean
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class MinimalClient extends ImmutableModel {
    static fromJS(json: MinimalClientModelType): MinimalClient {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): MinimalClientModelType {
        return {
            name: this.name,
            clientId: this.clientId,
            status: this.status,
            stage: this.stage,
            expiresOn: this.expiresOn,
            createdOn: this.createdOn,
            isTest: this.isTest
        };
    }

    get name(): string {
        return this._state.get('name');
    }

    setName(name: string): this {
        return this.clone(this._state.set('name', name));
    }

    get clientId(): string {
        return this._state.get('clientId');
    }

    setClientId(clientId: string): this {
        return this.clone(this._state.set('clientId', clientId));
    }

    get status(): ClientStatus {
        return this._state.get('status');
    }

    setStatus(status: ClientStatus): this {
        return this.clone(this._state.set('status', status));
    }

    get stage(): ClientStage {
        return this._state.get('stage');
    }

    setStage(stage: ClientStage): this {
        return this.clone(this._state.set('stage', stage));
    }

    get expiresOn(): ?string {
        return this._state.get('expiresOn');
    }

    setExpiresOn(expiresOn: ?string): this {
        return this.clone(this._state.set('expiresOn', expiresOn));
    }

    get createdOn(): string {
        return this._state.get('createdOn');
    }

    setCreatedOn(createdOn: string): this {
        return this.clone(this._state.set('createdOn', createdOn));
    }

    get isTest(): boolean {
        return this._state.get('isTest');
    }

    setIsTest(isTest: boolean): this {
        return this.clone(this._state.set('isTest', isTest));
    }
}
